import { motion } from "framer-motion";
import { HOW_STEPS } from "@/data/content";
import { SectionEyebrow } from "@/components/Marquee";

export default function HowItWorks() {
  return (
    <section id="how" className="relative py-20 md:py-28 bg-[#0A0A0F]" data-testid="how-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <SectionEyebrow n="Ch. IV" testId="how-eyebrow">How it Works</SectionEyebrow>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.8, 0, 0.2, 1] }}
          className="mt-6 font-serif text-white text-5xl sm:text-6xl md:text-7xl leading-[0.98] tracking-tight max-w-4xl"
        >
          Four moves. <span className="italic gradient-text">One clean deal.</span>
        </motion.h2>

        <div className="relative mt-20 grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          <div className="hidden lg:block absolute top-24 left-[6%] right-[6%] h-px" aria-hidden="true">
            <div className="w-full h-full gradient-bg opacity-30" />
            <motion.span
              initial={{ x: "-10%" }}
              whileInView={{ x: "110%" }}
              viewport={{ once: false, margin: "-100px" }}
              transition={{ duration: 3, ease: "easeInOut", repeat: Infinity, repeatType: "loop" }}
              className="absolute -top-1 w-2 h-2 rounded-full gradient-bg shadow-[0_0_16px_rgba(139,92,246,0.9)]"
            />
          </div>

          {HOW_STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: 0.15 * i, ease: [0.8, 0, 0.2, 1] }}
              className="relative rounded-3xl border border-white/5 bg-surface p-6 md:p-8 group"
              data-testid={`how-step-${s.n}`}
            >
              <div className="w-12 h-12 rounded-full grid place-items-center gradient-bg text-white font-serif text-lg shadow-[0_10px_30px_rgba(139,92,246,0.4)]">
                {s.n}
              </div>
              <h3 className="mt-7 font-serif text-xl md:text-2xl text-white leading-tight">{s.title}</h3>
              <p className="mt-4 text-silver/70 leading-relaxed text-sm md:text-base">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
